import { useLocation } from 'react-router-dom';

export const useGetQueryParam = (paramName: string): string | null => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  return params.get(paramName);
};
